import { useQuery, QueryFunction } from 'react-query';
import { getAllEntities, Entity, GetEntitiesQueries } from '../../services/apiSLTP/sites/entities';

type UseEntitiesQueryOptions = {
    queries?: GetEntitiesQueries;
};

const getEntitiesQuery: QueryFunction<Entity[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseEntitiesQueryOptions];
    const { queries } = options;

    const response = await getAllEntities(queries);
    return response.data;
};

export const useEntitiesQuery = (options: UseEntitiesQueryOptions) => {
    return useQuery(['entities', options], getEntitiesQuery);
};
